import { render, staticRenderFns } from "./Nature.vue?vue&type=template&id=1bd1d545&"
import script from "./Nature.vue?vue&type=script&lang=js&"
export * from "./Nature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports